/**
 * Change-bar gutter: a marker beside lines the working tree changed, not a
 * decoration on the text. Colour comes from the design token `--ok` so the
 * host theme owns it; inventing a hex here would drift from tavsin/design.md.
 */
import type { Extension } from "@codemirror/state";
import { EditorView, GutterMarker, gutter } from "@codemirror/view";

class ChangeBarMarker extends GutterMarker {
  override toDOM(_view: EditorView): HTMLElement {
    const el = document.createElement("div");
    el.className = "cm-change-bar";
    el.style.width = "2px";
    el.style.height = "100%";
    el.style.background = "var(--ok)";
    el.style.borderRadius = "1px";
    return el;
  }
}

const CHANGE_BAR = new ChangeBarMarker();

/** Empty / unknown sets render no gutter rather than pretending the file is clean. */
export function changeGutter(lines: ReadonlySet<number> | undefined): Extension {
  if (!lines || lines.size === 0) return [];
  return gutter({
    class: "cm-changebar",
    lineMarker: (view, block) => {
      const line = view.state.doc.lineAt(block.from).number;
      return lines.has(line) ? CHANGE_BAR : null;
    },
    initialSpacer: () => CHANGE_BAR,
  });
}
